import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ServerService} from './ServerService';

@Injectable({
  providedIn: 'root'
})
export class ComissionamentoService extends ServerService {
  constructor(http: HttpClient) {
    super(http);
  }

  listeComissionados(filtro: any = {}) {
    return this.obtenha('/comissionamento/comissionados', filtro);
  }

  salveComissionado(comissionado: any) {
    if(comissionado.id)
      return this.facaPut(`/comissionamento/comissionados/${comissionado.id}`, comissionado);

    return this.facaPost('/comissionamento/comissionados', comissionado);
  }

  removaComissionado(comissionado: any) {
    return this.remova(`/comissionamento/comissionados/${comissionado.id}`, {});
  }

  listeComissoes(filtro: any = {}) {
    return this.obtenha('/comissionamento/comissoes', filtro);
  }

  atualizeLabel(label: string) {
    return this.facaPut('/comissionamento/configuracao/label', {label});
  }

  salveComissao(comissao: any) {
    if(comissao.id)
      return this.facaPut(`/comissionamento/comissoes/${comissao.id}`, comissao);

    return this.facaPost('/comissionamento/comissoes', comissao);
  }

  removaComissao(comissao: any) {
    return this.remova(`/comissionamento/comissoes/${comissao.id}`, {});
  }

  listeProdutos(filtro: any = {}) {
    const params: any = {};
    if(filtro.catalogoId)
      params.catalogoId = filtro.catalogoId;
    if(String(filtro.busca || '').trim())
      params.busca = String(filtro.busca).trim();
    if(filtro.categoriaId)
      params.categoriaId = filtro.categoriaId;
    if(filtro.comissaoId)
      params.comissaoId = filtro.comissaoId;
    if(filtro.disponivelParaComissao)
      params.disponivelParaComissao = 1;

    return this.obtenha('/comissionamento/produtos', params);
  }

  vinculeProdutos(comissaoId: number, catalogoId: number, produtoIds: number[]) {
    return this.facaPut(`/comissionamento/comissoes/${comissaoId}/produtos`, {catalogoId, produtoIds});
  }

  vinculeCategoria(comissaoId: number, catalogoId: number, categoriaId: number) {
    return this.facaPost(`/comissionamento/comissoes/${comissaoId}/produtos/categoria`, {catalogoId, categoriaId});
  }

  desvinculeProdutos(catalogoId: number, produtoIds: number[] = [], comissaoId: number = null) {
    return this.http.delete('/comissionamento/produtos', {
      body: {catalogoId, produtoIds, comissaoId}
    }).toPromise().then(this.retorno).catch(this.handleError);
  }

  listeItensPedido(guidPedido: string) {
    return this.obtenha(`/comissionamento/pedidos/${guidPedido}/itens`, {});
  }

  atribuaComissionadoItem(guidPedido: string, itemPedidoId: number, comissionadoId: number, justificativa: string = null) {
    return this.facaPut(`/comissionamento/pedidos/${guidPedido}/itens/${itemPedidoId}/comissionado`, {comissionadoId, justificativa});
  }

  relatorio(filtro: any) {
    return this.obtenha('/comissionamento/relatorio', filtro);
  }
}
